import { VehicleDTO } from "@/src/types/types";
import { omit } from "@/src/utils/common";

export const getGTMVehicleData = (vehicle: VehicleDTO | undefined) => {
  return vehicle ? omit(vehicle, "regNo") : undefined;
};
